// ── Implémentation ────────────────────────────────────────────────────────────
export class AdminClientImpl {
    http;
    sim;
    constructor(http, sim) {
        this.http = http;
        this.sim = sim;
    }
    // Users
    listUsers() {
        return this.http.get('/api/v1/admin/users', async () => (this.sim?.getAdminData('users') ?? []));
    }
    createUser(payload) {
        return this.http.post('/api/v1/admin/users', payload, async () => ({ ...payload, id: `demo-${Date.now()}`, is_premium: false, is_active: true, totp_enabled: false }));
    }
    updateUserRole(userId, role, clearance) {
        return this.http.patch(`/api/v1/admin/users/${userId}/role`, { role, clearance }, async () => ({ id: userId, email: '', role, clearance, is_premium: false, is_active: true, totp_enabled: false }));
    }
    changeUserPassword(userId, newPassword) {
        return this.http.patch(`/api/v1/admin/users/${userId}/password`, { new_password: newPassword }, async () => undefined);
    }
    deleteUser(userId) {
        return this.http.delete(`/api/v1/admin/users/${userId}`, async () => undefined);
    }
    // Users TOTP Management
    setupUserTotp(userId) {
        return this.http.post(`/api/v1/admin/users/${userId}/totp/setup`, {}, async () => ({
            otpauth_uri: `otpauth://totp/Assistia:demo@luminya.eu?secret=JBSWY3DPEHPK3PXP&issuer=Assistia`,
            secret: 'JBSWY3DPEHPK3PXP',
        }));
    }
    enableUserTotp(userId, code) {
        return this.http.post(`/api/v1/admin/users/${userId}/totp/enable`, { code }, async () => ({
            recovery_codes: Array.from({ length: 8 }, (_, i) => `DEMO-FAKE-CODE-000${i + 1}`),
        }));
    }
    disableUserTotp(userId) {
        return this.http.post(`/api/v1/admin/users/${userId}/totp/disable`, {}, async () => undefined);
    }
    // Premium
    grantPremium(userId) {
        return this.http.post('/api/v1/admin/premium/grant', { user_id: userId, granted_by: 'admin' }, async () => undefined);
    }
    revokePremium(userId) {
        return this.http.post('/api/v1/admin/premium/revoke', { user_id: userId, revoked_by: 'admin' }, async () => undefined);
    }
    // Health
    getHealth() {
        const simDefault = {
            timestamp: new Date().toISOString(),
            overall: 'healthy',
            components: {
                api: { status: 'ok', latency_ms: 2, version: 'dev', uptime_s: 0 },
                postgres: { status: 'ok', latency_ms: 5, sessions: 1, db_size_mb: 10 },
                redis: { status: 'ok', latency_ms: 1, used_mb: 4, max_mb: 128, used_pct: 3, keys: 42 },
                disk: { status: 'ok', used_pct: 30, free_gb: 20, total_gb: 30 },
                workers: { status: 'ok', active: 1, queue_depth: 0 },
                ssl: { status: 'ok', expires_in_days: 60 },
            },
        };
        return this.http.get('/api/v1/admin/health', async () => simDefault);
    }
    getHealthDeep() {
        return this.http.get('/api/v1/admin/health/deep', async () => this.sim?.getAdminData('health')?.[0] ?? { status: 'degraded', checks: {}, checked_at: new Date().toISOString() });
    }
    // Licenses
    createLicense(payload) {
        return this.http.post('/api/v1/admin/licenses', payload, async () => ({ id: `lic-${Date.now()}`, valid_until: payload.valid_until }));
    }
    updateLicense(licenseKeyHash, payload) {
        return this.http.patch(`/api/v1/admin/licenses/${licenseKeyHash}`, payload, async () => ({ id: licenseKeyHash, valid_until: payload.valid_until }));
    }
    getLicense(licenseKeyHash) {
        return this.http.get(`/api/v1/admin/licenses/${licenseKeyHash}`, async () => ({ id: licenseKeyHash, user_id: 'u-demo-001', features: {}, valid_until: new Date().toISOString(), created_at: new Date().toISOString() }));
    }
    getLicenseStatus() {
        return this.http.get('/api/v1/admin/licenses/status', async () => ({ ok: true }));
    }
}
//# sourceMappingURL=admin.js.map